/**
 * The external dependencies.
 */
import {all, call, takeLatest} from 'redux-saga/effects';
/**
 * The internal dependencies.
 */
import request from '../../common/request';
import {errorSelect, getErrorDetails, qualityGetTasks, qualityRecieveTasks, storeErrorDetails} from './actions';

/**
 * Start a network request to fetch content.
 *
 * @param  {Object}    action
 * @return {Generator}
 */
export function* workerQualityGetTasks(action) {

    yield call(request, {
        endpoint: 'getErrortracking',
        params: [],
        requestAction: action,
        receiveAction: qualityRecieveTasks,
    });
}

export function* workerGetTask(action) {
    yield call(request, {
        endpoint: 'getDetails',
        params: [action.payload.uuid],
        requestAction: action,
        receiveAction: storeErrorDetails,
    });

}

export function* workerGetInstructions(action) {
    // const task = action.payload.task;
    // console.log("workerGetInstructions", action.payload)
    /*yield call(request, {
        endpoint: 'getTasksSteps',
        params: [{
            client: task.order_client,
            erpnumber: task.erpnumber
        }],
        requestAction: action,
        receiveAction: tasksRecievedInstructions,
    });*/
}

/**
 * Coordinate the workers.
 *
 * @return {Generator}
 */
export default function* ContentForeman() {
    yield all([
        takeLatest(qualityGetTasks, workerQualityGetTasks),
        takeLatest(getErrorDetails, workerGetTask),
        takeLatest(errorSelect, workerGetInstructions),
    ]);
}



// WEBPACK FOOTER //
// ./src/store/quality/effects.js